import React from 'react';
import Markdown from 'react-markdown';

function SlideText({ caption }) {
  return <Markdown className="rcw-page-slider-caption">{caption}</Markdown>;
}

export default SlideText;
